module.exports = __webpack_public_path__ + "static/media/jinx-title.9ae84733.png";